import Vue from 'vue';
import Router from 'vue-router';

import HomePage from '../home/HomePage'
import LoginPage from '../login/LoginPage'
import CompetitionPage from '../competition/CompetitionPage'
// import DayPage from '../day/DayPage'
import CompetitionAdminPage from '../competition/CompetitionAdminPage'
import CatchAdminPage from '../catch/CatchesPage'

Vue.use(Router);

function livePropsFn (route) {
  return {
    id: route.params.id,
    dayId: route.params.dayId,
    live: true,
  }
}

export const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'home',  component: HomePage },
    { path: '/login', name: 'login', component: LoginPage },
    { path: '/competition/:id', component: CompetitionPage, props: true },
    { path: '/competition/:id/day/:dayId', component: CompetitionPage, props: true },
    { path: '/live/:id/day/:dayId', component: CompetitionPage, props: livePropsFn },
    { path: '/edit/competition/:id', component: CompetitionAdminPage, props: true },
    { path: '/edit/day/:id', component: CatchAdminPage, props: true },

    // otherwise redirect to home
    { path: '*', redirect: '/' }
  ]
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page

  var authRequired = false
  var basePath = to.path.split('/')[1]
  if (basePath == 'edit') {
    authRequired = true
  }
  const loggedIn = localStorage.getItem('user');

  if (authRequired && !loggedIn) {
    return next('/login');
  }

  next();
})
